export default __webpack_public_path__ + "static/media/logout.af4457f2.svg";